import React, { useState } from "react";
import { Modal, Button, Upload, Alert, Space, Typography, Card } from "antd";
import {
  UploadOutlined,
  FileExcelOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import axios from "axios";
import { Api_Url } from "../../../config/config";
import { ErrorToast, SuccessToast } from "../../ToastComponent";

const { Text } = Typography;

export const FileMovementBulkUploadModal = ({ onClose, onSuccess }) => {
  const [fileList, setFileList] = useState([]);
  const [uploading, setUploading] = useState(false);

  const getAuthHeader = () => ({
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("user"))?.accessToken}`,
      "Content-Type": "multipart/form-data",
    },
  });

  const handleUpload = async () => {
    if (fileList.length === 0) {
      ErrorToast("Please select a file first");
      return;
    }

    const formData = new FormData();
    formData.append("File", fileList[0]);

    setUploading(true);
    try {
      const response = await axios.post(
        `${Api_Url}api/v1/FileMovement/bulk-upload`,
        formData,
        getAuthHeader(),
      );

      if (response.data.succeeded) {
        SuccessToast(response.data.message || "Bulk upload successful");
        onSuccess();
        onClose();
      } else {
        ErrorToast(response.data.message || "Upload failed");
      }
    } catch (error) {
      console.error("Upload error:", error);
      ErrorToast(error.response?.data?.message || "Error uploading file");
    } finally {
      setUploading(false);
    }
  };

  const downloadTemplate = () => {
    const headers = [
      "Application No.,Loan Number,Movement Date,Storage Name,File BarCode no,Box bar code no,Movement",
    ];
    const blob = new Blob([headers.join("\n")], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "File_Movement_Template.csv";
    a.click();
    window.URL.revokeObjectURL(url);
  };

  const uploadProps = {
    onRemove: (file) => {
      setFileList([]);
    },
    beforeUpload: (file) => {
      const isCsv = file.type === "text/csv" || file.name.endsWith(".csv");
      if (!isCsv) {
        ErrorToast("You can only upload CSV files!");
        return Upload.LIST_IGNORE;
      }
      setFileList([file]);
      return false; // Prevent automatic upload
    },
    fileList,
  };

  return (
    <Modal
      title="Bulk Upload File Movements"
      open={true}
      onCancel={onClose}
      footer={[
        <Button key="back" onClick={onClose}>
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={uploading}
          onClick={handleUpload}
          disabled={fileList.length === 0}
        >
          Start Upload
        </Button>,
      ]}
    >
      <Space direction="vertical" style={{ width: "100%" }} size="middle">
        <Alert
          message="Instructions"
          description={
            <ul className="ps-3 mb-0">
              <li>Use only the provided CSV template.</li>
              <li>Date format should be YYYY-MM-DD.</li>
              <li>
                Movement types: SEND_TO_STORAGE, RECEIVE_FROM_STORAGE,
                RECIEVE_FROM_BRANCH.
              </li>
            </ul>
          }
          type="info"
          showIcon
        />

        <Card
          size="small"
          style={{ textAlign: "center", backgroundColor: "#f9f9f9" }}
        >
          <Text db>
            Download the template to ensure correct data formatting:
          </Text>
          <Button
            type="link"
            icon={<DownloadOutlined />}
            onClick={downloadTemplate}
            style={{ marginTop: 8 }}
          >
            Download CSV Template
          </Button>
        </Card>

        <Upload.Dragger {...uploadProps} maxCount={1}>
          <p className="ant-upload-drag-icon">
            <FileExcelOutlined style={{ color: "#198754" }} />
          </p>
          <p className="ant-upload-text">
            Click or drag CSV file to this area to upload
          </p>
          <p className="ant-upload-hint">
            Support for a single bulk CSV file only.
          </p>
        </Upload.Dragger>
      </Space>
    </Modal>
  );
};
